import React, { useState, useEffect } from 'react';

const GoogleAnalyticsFields = ({ gaClientId, gaSessionId, setGaClientId, setGaSessionId }) => {
  const [timeout, setTimeout] = useState(null)

  const isGtagApiEvent = (event) => {
    return event?.value?.gtagApiResult != null
  }

  const getGtagApiData = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      const gtagApiEvents = window.dataLayer.filter(item => item.value?.event === 'gtagApiGet');
      const latestGtagApiEvent = gtagApiEvents.length > 0 ? gtagApiEvents[gtagApiEvents.length - 1] : null;

      if (isGtagApiEvent(latestGtagApiEvent)) {
        setGaClientId(latestGtagApiEvent.value.gtagApiResult.client_id);
        setGaSessionId(latestGtagApiEvent.value.gtagApiResult.session_id);
      }
    }
  };

  useEffect(() => {
    if (gaClientId !== '' && gaSessionId !== '') {
      clearInterval(timeout)
    }
  }, [gaClientId, gaSessionId, timeout])

  useEffect(() => {
    setTimeout(setInterval(() => {
      getGtagApiData()
    }, 1000))

    return () => clearInterval(timeout)
  }, [])

  return (
    <div>
      <input type="hidden" id="gaClientId" name="woohoo[ga_client_id]" value={gaClientId} />
      <input type="hidden" id="gaSessionId" name="woohoo[ga_session_id]" value={gaSessionId} />
    </div>
  )
}

export default GoogleAnalyticsFields;